import React, { useState } from 'react';
import Form from 'rsuite/Form';
import { InputGroup } from 'rsuite';
import Button from 'rsuite/Button';
import Panel from 'rsuite/Panel';
import Message from 'rsuite/Message';
import Schema from 'rsuite/Schema';
import ButtonToolbar from 'rsuite/ButtonToolbar';
import { useDispatch, useSelector } from 'react-redux';
import 'Components/login/login.css';
import { loginAction } from 'Components/login/state/loginAction';
import { useNavigate } from 'react-router-dom';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';

const { StringType } = Schema.Types;
const schemaModel = Schema.Model({
  email: StringType().isEmail('El correo electrónico no es valido.').isRequired('Campo requerido'),
  password: StringType().isRequired('Campo requerido').minLength(8, 'La contraseña debe contener minio 8 caracteres'),
});

function TextField(props) {
  const { name, label, helpText, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}`}>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest}></Form.Control>
      {helpText && <Form.HelpText className="color__red">{helpText}</Form.HelpText>}
    </Form.Group>
  );
}

function PassField(props) {
  const [visible, setVisible] = React.useState(false);
  const handleChange = () => {
    setVisible(!visible);
  };
  const { name, label, helpText, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}`}>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <InputGroup inside>
        <Form.Control name={name} accepter={accepter} type={visible ? 'text' : 'password'} {...rest}></Form.Control>
        <InputGroup.Button onClick={handleChange}>{visible ? <EyeIcon /> : <EyeSlashIcon />}</InputGroup.Button>
        {helpText && <Form.HelpText className="color__red">{helpText}</Form.HelpText>}
      </InputGroup>
    </Form.Group>
  );
}

export default function LoginForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginState = useSelector((state) => state.auth);
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  

  /**
   * @description Event - Iniciar sesion
   * @param {bool} isValid
   */
  const handleSubmit = (isValid) => {
    if (isValid) {
      setLoading(true);
      dispatch(loginAction(form.email, form.password))
        .then((res) => {
          setLoading(false);
          navigate('/main/fe');
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  return (
    <Panel className="panel__login" header={<h3>Iniciar sesión</h3>}>
      <Form fluid model={schemaModel} onChange={setForm} onSubmit={handleSubmit}>
        <TextField name="email" label="Correo electrónico" />
        <PassField name="password" label="Contraseña" autoComplete="off"/>
        {loginState.error && (
          <Message type="error">
            {loginState.error}
          </Message>
        )}
        <br></br>
        <Form.Group>
          <ButtonToolbar>
            <Button size="lg" type="submit" appearance="primary" block loading={loading}>
              Iniciar sesión
            </Button>
          </ButtonToolbar>
        </Form.Group>
      </Form>
    </Panel>
  );
}
